import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-label',
    templateUrl: './label.component.html',
    styleUrls: ['./label.component.scss']
})
export class LabelComponent implements OnInit {

    @Input() name: string;
    @Input() value: any;
    @Input() valueIcon: string = null;
    @Input() iconLibrary: 'material' | 'prime' | 'fontawesome' | 'custom' = 'fontawesome';
    @Input() iconType: 'info' | 'warning' | 'danger' | 'white' = 'info';
    @Input() tooltip: string = null;
    @HostBinding('class') @Input() flow: 'inline' | 'column' | 'new' = 'column'

    constructor() {
    }

    ngOnInit() {
    }

    get display() {
        if (null == this.value || '' === this.value) {
            return 'N/A';
        }
        return this.value;
    }
}
